import { Box, Skeleton } from '@mui/material'
import { createArrayOfNumbers } from '../../../utils/helpers';

const NotificationCenterSkeleton = ({ size = 1 }) => (
  <Box sx={styles.root}>
    {createArrayOfNumbers(size).map((item) => (
      <Box sx={styles.notificationCard} key={item}>
        <Box sx={styles.cardIconWithTitle}>
          <Box sx={styles.notificationIconContainer}>
            <Skeleton variant="rounded" width={50} height={50} />
          </Box>
          <Skeleton variant="text" sx={styles.cardTitleHeader} />
        </Box>
        <Skeleton variant="text" sx={styles.cardDetails} />
        <Box sx={styles.cardDateTime}>
          <Skeleton variant="text" sx={styles.cardDate} />
          <Skeleton variant="text" sx={styles.cardTime} />
        </Box>
      </Box>
    ))}
  </Box>
)

const styles = {
  root: {
    backgroundColor: 'background.paper',
  },
  notificationCard: {
    display: 'grid',
    alignItems: { xs: 'unset', sm: 'center' },
    gridTemplateColumns: { xs: '1fr', sm: '1.5fr 4fr 1fr' },
    boxSizing: 'border-box',
    height: { xs: 'unset', sm: '128px' },
    padding: { xs: '13px', sm: '20px 70px 40px 40px' },
    gap: { xs: '16px', sm: '40px' },
    marginBottom: 0,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.100',
  },
  cardIconWithTitle: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    height: 'fit-content',
    paddingLeft: {
      xs: '0px',
      sm: '40px',
    },
  },
  notificationIconContainer: {
    display: { xs: 'none', sm: 'flex' },
  },
  cardTitleHeader: {
    width: '100px',
    height: '24px',
  },
  cardDetails: {
    width: '300px',
    height: '24px',
    marginLeft: {
      xs: '0px',
      sm: '40px',
    },
  },
  cardDateTime: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    alignItems: 'center',
    justifyContent: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '10px', sm: '0px' },
  },
  cardDate: {
    width: { xs: '80px', sm: '130px' },
    height: '24px',
  },
  cardTime: {
    width: { xs: '60px', sm: '70px' },
    height: '24px',
  },
}
export default NotificationCenterSkeleton
